var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "favorites-btn",
      class: _vm.is_open_dialog ? "open" : "close",
      attrs: { id: "favorites_btn" }
    },
    [
      _vm.show_favorites_btn_notice
        ? _c("div", { staticClass: "btn-notice__content" }, [
            _vm._v("\n        我的最愛 ! 請參考使用說明 "),
            _c("br"),
            _vm._v("\n        關於 > 怎麼用 > 操作說明\n        "),
            _c(
              "button",
              {
                staticClass: "btn-notice__btn",
                on: { click: _vm.not_show_favorites_btn_notice }
              },
              [_vm._v("\n            知道了\n        ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "favorites-btn__container" },
        [
          _c(
            "v-icon",
            {
              staticClass: "favorites-btn__icon",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.open_dialog()
                }
              }
            },
            [_vm._v("\n            icon-heart-regular\n        ")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "favorites-btn__text" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("__favorites.hint_text")) +
                "\n        "
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.is_open_dialog
        ? _c("FavoritesSettingItems", {
            staticClass: "setting-items",
            on: {
              close_dialog: function($event) {
                return _vm.close_dialog()
              },
              change_favorites_hint_text: _vm.change_favorites_hint_text
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }